// ArgsDiff — before/after rows for the fields an edit changed (standing-agent-ui
// "Edit shows a diff"). Values in monospace; "before" is struck through but
// also labelled by its column header, never conveyed by styling alone.

import { displayValue, type ArgChange } from './schemaArgs';

export function ArgsDiff({ changes }: { changes: ArgChange[] }) {
  if (changes.length === 0) {
    return <p className="pz-hint">No changes yet.</p>;
  }
  return (
    <table className="pz-diff" aria-label="Changes">
      <thead>
        <tr>
          <th scope="col">Field</th>
          <th scope="col">Before</th>
          <th scope="col">After</th>
        </tr>
      </thead>
      <tbody>
        {changes.map((c) => (
          <tr key={c.name}>
            <th scope="row" className="pz-mono">
              {c.name}
            </th>
            <td className="before">{displayValue(c.before)}</td>
            <td>{displayValue(c.after)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ArgsDiff;
